import { KestrelGatekeeper, KestrelInspectionType } from 'types'

export const GATEKEEPER_DEFAULTS: KestrelGatekeeper = {
  kind: KestrelInspectionType.DEFAULT,
  fallbackUnit: 'Meters',
  feature: {
    layerHotbar: false,
    changeTexture: true,
    plane2D: true,
    cameraPoses: true,
    drawInspectionAreas: true,
    toggleInspectionGridButton: false,
    dataValidationControl: false,
    thermalGradientPanel: false,
    temperatureDisplay: false,
    inspectionGridSettings: false,
    infoModal: false,
    exportControls: true,
    unitTaggingControls: false,
    allowThicknessMeasurement: true,
    defectsReportWithScreenshots: false,
    labelVisible: true,
    areaVisible: false,
    compassVisible: false,
    labelCullingEnabled: true,
    temperatureProbeUsesCursorData: false,
    annotationFormButton: false,
    aircraftMetadata: false,
    primitiveGeometryAsAnnotation: true,
  },
  annotationForm: {
    showLabelInput: true,
    showTopSeverityRow: true,
    showDamageTypeSelector: false,
    damageLabel: 'Damage Type',
    severityBelowDamage: false,
    showG1N6Dimensions: false,
    showG1N6Location: false,
    showNavyLocation: false,
    showTags: true,
    showScreenshots: false,
    showNotes: true,
    showGeospatialLink: false,
    annotationMenuScrollable: false,
  },
}
